var _path, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDhlLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.094,
    height: 19.829,
    viewBox: "0 0 140.094 19.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,68.252H18.9l-1.022,1.38H0Zm0-2.615H20.868l-1.022,1.38H0Zm0,5.229H17l-1.022,1.38H0Z",
    transform: "translate(0 -52.491)",
    fill: "#d40511"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(119.298 13.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M616.423,69.632h-18.9l1.022-1.38h17.876Zm0,2.615h-20.8l1.021-1.38h19.774Zm-15.907-6.61h15.907v1.38h-17Z",
    transform: "translate(-595.628 -65.638)",
    fill: "#d40511"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(18.314 7.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M91.439,50.207l8.975-12.13h11.164c1.24,0,1.24.436.584,1.307-.584.8-1.678,2.252-2.262,3.051-.292.436-.876,1.235,1.022,1.235h14.958a15.582,15.582,0,0,1-12.55,6.61c-5.837-.073-21.89-.073-21.89-.073Zm51.514-6.61-4.889,6.61H125.222l4.889-6.61Zm18.606,0-4.889,6.61H143.828l4.889-6.61Zm4.159,0s-.948,1.307-1.386,1.888c-1.605,2.179-.219,4.721,5.108,4.721h20.649l4.889-6.61Z",
    transform: "translate(-91.439 -38.077)",
    fill: "#d40511"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(20.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M105,0l-4.451,6.029h24.37c1.24,0,1.24.436.584,1.307-.584.8-1.605,2.252-2.262,3.123-.292.436-.875,1.235,1.022,1.235h10s1.605-2.179,2.919-3.995C139,5.229,137.32.073,130.753.073,124.99,0,105,0,105,0Zm64.939,11.621H138.488L147.1,0H159.94l-4.962,6.682h5.764L165.7,0h12.842ZM196.35,0l-8.61,11.621H174.1L182.705,0Z",
    transform: "translate(-100.546 0)",
    fill: "#d40511"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhlLogo);
export default __webpack_public_path__ + "static/media/dhl-logo.d161943c.svg";
export { ForwardRef as ReactComponent };